<template>
  <div class="showhidePage" v-if="showHide">
    <div class="block_showhide">
      <div class="showpageHead">
        <div class="leftTitle">列显隐</div>
        <div class="iconclose">
          <i
            class="el-icon-close"
            @click="
              () => {
                showHide = false;
              }
            "
          ></i>
        </div>
      </div>
      <div class="content_hide">
        <div class="content_all">
          <div class="head_content_all">
            <div>显示列表项</div>
            <div>{{ checkedList.length }}/{{ countShowplainOption }}</div>
          </div>

          <div class="content_list firstcontent_list">
            <a-input-search
              style="width: 80%; margin: 12px 0"
              placeholder="请输入搜索内容"
              @search="onSearch"
            />
            <div class="content_list_auto">
              <a-checkbox-group v-model="checkedList" @change="onChange">
                <a-checkbox
                  class="charkones"
                  v-show="item.hideshow != true && !item.labelshow"
                  v-for="item in plainOptions"
                  :key="item.label"
                  :value="item"
                  :name="item.label"
                  defaultChecked="true"
                  :disabled="item.fixed"
                  >{{ item.label }}{{ item.hideshow }}
                </a-checkbox>
              </a-checkbox-group>
            </div>
          </div>
        </div>
        <div class="content_all rightcontent">
          <div class="head_content_all">
            <div>
              列排序
              <span class="sizefont">( 标红字段不可更改 )</span>
            </div>
          </div>

          <div class="content_list">
            <div class="paixulist">
              <div
                v-for="(item, index) in checkedList"
                :key="index"
                class="listpaixu"
              >
                <div class="leftspnblock">
                  <!-- {{index+1}}
                  <span class='listnamespan'>{{ item.label }}</span> -->
                  <span v-if="index + 1 - flexIndex > 0">{{
                    index + 1 - flexIndex
                  }}</span>

                  <span
                    :class="[
                      'listnamespan',
                      item.fixed == true ? 'bleckcolor' : '',
                    ]"
                    >{{ item.label }}</span
                  >
                </div>

                <div class="rightspan" v-if="!item.fixed">
                  <div class="icon_but" v-if="index - flexIndex != 0">
                    <a-icon
                      type="vertical-align-top"
                      title="置顶"
                      @click="zhiding(index)"
                    />
                  </div>
                  <div
                    class="icon_but"
                    style="width: 25px"
                    v-if="index - flexIndex == 0"
                  ></div>
                  <div class="icon_but" v-show="index - flexIndex != 0">
                    <a-icon type="arrow-up" title="向上" @click="uper(index)" />
                  </div>
                  <div class="icon_but">
                    <div
                      class="icon_but"
                      style="width: 12px"
                      v-if="index == checkedList.length - 1"
                    ></div>
                    <a-icon
                      v-if="index != checkedList.length - 1"
                      type="arrow-down"
                      title="向下"
                      @click="down(index)"
                    />
                  </div>
                  <div class="icon_but" style="width: 15px">
                    <a-icon
                      v-if="index != checkedList.length - 1"
                      type="vertical-align-bottom"
                      title="置底"
                      @click="downding(index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="but_que_cancel">
        <div class="multiplechoice">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
          >
            全选
          </a-checkbox>
        </div>
        <div>
          <el-button @click="cancel"> 取消</el-button>
          <el-button type="primary" class="cherk_but" @click="checkreturn"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//   columnBtn: false,

// <template slot="menuRight" slot-scope="scope">
//    <el-tooltip class="item" effect="dark" content="显隐"
//           placement="top">
//          <el-button icon="el-icon-s-operation"
//            circle @click="operation" ></el-button>
//        </el-tooltip>
//        </template>

// <Options ref="Options"
//         :plainOptions="option.column"
//         :pageDataId="this.$route.path"
//         @returnData="returnData"
//       />

// import Options from "@/components/ShowHidden/showhidden";

// *   option.column  (不需要显示在显隐插件中的填写) hideshow:true
// *
//    //显隐
//     operation() {
//       this.$refs.Options.showmode();
//     },
//      //回调
//     returnData(data) {
//       this.option.column = data;
//     },
// *
// *

import * as api from "@/api/text/text";
export default {
  name: "showhide",
  data() {
    return {
      showHide: false,
      pageRouteId: "",
      countShowplainOption: 0,
      checkedList: [],
      searchVal: [],
      nocheckedList: [],
      plainOptionscope: [],
      hideoption: [],
      indeterminate: true,
      checkAll: false,
      flexIndex: 0,
      flexcheckList: [],
    };
  },
  props: {
    plainOptions: { type: Array },
    pageDataId: { type: String },
  },
  watch: {
    plainOptions: {
      handler(newData, oldData) {
        // console.info(oldData, 'planOptions----oldData')
        // console.info(newData, 'planOptions----newData')
        if(Array.isArray(newData) && JSON.stringify(newData) != JSON.stringify(oldData)) {
          this.plainOptionscope = this.deepClone(newData);
          let contplainOptions = newData.length;
          newData.forEach((item, index) => {
            item.labelshow = false;
            if (item.hide && item.hide == true) {
              contplainOptions = contplainOptions - 1;
              this.plainOptionscope.splice(index, 1);
            } else {
              
              if (item.fixed == true) {
                this.flexIndex += 1;
              }
              return item;
            }
          });
          this.countShowplainOption = contplainOptions;
          // console.info(contplainOptions, 'planOptions----countShowplainOption')
          this.getFieldListPage(1);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取显隐
    // 1显示接口返回数据
    getFieldListPage(showHide) {
      let that = this
      // this.checkedList = [];
      api.getRoutesId({ path: this.pageDataId }).then((re) => {
        this.pageRouteId = re.data.data;
        // console.info(re.data.data, 'pageRouteId')
        //右侧选中
        api.getFieldList({ menuId: re.data.data, overtOrCovert: showHide }).then((res) => {
            let checkedList = [];
            // 过滤/api/field/getFieldList有返回且hideshow不为true的字段
            // let self = this.plainOptions.filter((item) => {
            //   return (
            //     res.data.data.findIndex((val) => {
            //       return val.title == item.label;
            //     }) > -1 && !item.hideshow
            //   );
            // });

            let self = []
            res.data.data.map((itemOne) => {
              that.plainOptions.map( itemTwo => {
                if(itemOne.title == itemTwo.label && !itemTwo.hideshow){
                  self.push(itemTwo)
                }
              })
            })

            //  过滤隐藏的字段
            let hideShowcloum = this.plainOptions.filter((item) => {
              return item.hideshow;
            });
            //  合并数组
            self.forEach((selfitem) => {
              hideShowcloum.push(selfitem);
            });
            // console.log(hideShowcloum);
            this.checkedList = self;
            if (self.length != 0) {
              this.$emit("returnData", hideShowcloum);
            }
          });
      });
    },
    showmode() {
      this.showHide = true;
      this.flexcheckList = [];
      // this.getFieldListPage(1);
      this.searchVal = this.plainOptions;
      this.plainOptions.forEach((item) => {
        if (item.fixed && !item.hideshow) {
          this.flexcheckList.push(item);
          //  this.checkedList.push(item)
        }
      });
      this.plainOptions.map((item) => {
        item.labelshow = false;
      });
    },
    onChange(checkedList) {
      // console.log(checkedList);
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length;
      this.checkedList = this.checkedList.filter((item) => item.fixed != true);
      // this.checkedList = [ ...this.checkedList];
      // let self=this.flexcheckList
      // this.checkedList.filter((item,index,self)=>{
      //   return self.findIndex(val=>{return val.label==item.label})==index
      // })

      this.checkedList = [...this.flexcheckList, ...this.checkedList];
    },
    down(index) {
      let acount = this.checkedList.length;
      if (index + 1 < acount) {
        let changesdown = this.checkedList[index + 1];
        let change = this.checkedList[index];
        this.$set(this.checkedList, index + 1, change);
        this.$set(this.checkedList, index, changesdown);
      }
      // console.log(this.checkedList);
    },
    uper(index) {
      if (index - 1 >= 0) {
        let changesdown = this.checkedList[index - 1];
        let change = this.checkedList[index];
        this.$set(this.checkedList, index - 1, change);
        this.$set(this.checkedList, index, changesdown);
      }
      // console.log(this.checkedList);
    },
    // 置顶
    zhiding(index) {
      if (index != 0) {
        let changesdown = this.checkedList[index];
        this.checkedList.splice(index, 1);
        this.checkedList = this.checkedList.filter(
          (item) => !item.fixed && !item.hideshow
        );

        this.checkedList.unshift(changesdown);
        this.checkedList = [...this.flexcheckList, ...this.checkedList];

        // this.checkedList = [...this.flexcheckList, ...this.checkedList];
        //  this.flexcheckList.forEach(item=>{
        //     this.checkedList.unshift(item)
        //  })
      }
    },
    //置底
    downding(index) {
      let acount = this.checkedList.length - 1;
      if (index != acount) {
        let changesdown = this.checkedList[index];
        this.checkedList.splice(index, 1);
        this.checkedList.push(changesdown);
      }
      // console.log(this.checkedList);
    },
    //提交数据
    checkreturn() {
      let saveLisyData = [];
      let that = this;

      that.checkedList.map((item, index) => {
        saveLisyData.push({
          title: item.label,
          name: item.prop,
          order: index,
          overtOrCovert: 1,
          hied: item.hied,
          formatter: () => {}
        });
        if( item.formatter ) { saveLisyData[index].formatter = JSON.stringify(item.formatter) }
      });
      api
        .saveFieldList({ menuId: that.pageRouteId, nameList: saveLisyData })
        .then((res) => {
          // console.log(res);
          // 选中 并且 排序完整的数组
          if (res.data.data.length == undefined) {
            return;
          }
          let checkedList = res.data.data;
          // let checkedLists = this.checkedList;
          // 完整的数组
          let plainOptions = that.plainOptions;
          let noCheckedList = [];
          let isCheckedList = [];
          // if(checkedList!=[]){

          noCheckedList = plainOptions.filter((item) => {
            return (
              checkedList.findIndex((val) => val.fieldName == item.prop) == -1
            );
          });
          checkedList.forEach((item) => {
            if(item.formatter) item.formatter = JSON.parse(item.formatter)
            let indexParent = plainOptions.findIndex(
              (val) => val.prop == item.fieldName
            );
            isCheckedList.push(plainOptions[indexParent]);
          });
          // }
          let newPlainOptions = [
            ...isCheckedList.map((item) => {
              return {
                ...item,
                hide: false,
              };
            }),
            ...noCheckedList.map((item) => {
              return {
                ...item,
                hide: true,
              };
            }),
          ];
          // this.hideoption.forEach(items => {
          //   newPlainOptions.push(items)
          // });

          that.$emit("returnData", newPlainOptions);
          this.showHide = false;
        });
    },

    cancel() {
      this.showHide = false;
    },
    // 多选
    onCheckAllChange(e) {
      let newcheckedList = [];
      this.plainOptions.forEach((item) => {
        if (item.hideshow != true) {
          // flexcheckList
          newcheckedList.push(item);
        }
      });
      Object.assign(this, {
        checkedList: e.target.checked ? newcheckedList : [],
        indeterminate: false,
        checkAll: e.target.checked,
      });
      // this.$nextTick(()=>{
      //   console.log(this.checkedList)
      // })
      // console.log( this.checkedList)
    },
    onSearch(val) {
      let plainOptions = this.plainOptions.slice(0);
      if (val != "") {
        plainOptions.map((item) => {
          item.labelshow = item.label.indexOf(val) != -1 ? false : true;
        }); 
        this.plainOptions = plainOptions;
      } else {
        plainOptions.map((item) => {
          item.labelshow = false;
        });
        this.plainOptions = plainOptions;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .showhidePage {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    .block_showhide {
      position: relative;
      background: #fff;
      width: 600px;
      height: 520px;
      border-radius: 5px;
      .showpageHead {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #ddd;
        // box-shadow: 0px 2px 6px 0px #ddd;
        padding: 8px 25px;
        .leftTitle {
          font-size: 18px;
          // line-height: ;
          // font-weight: bold;
        }
        .iconclose {
          font-size: 25px;
          cursor: pointer;
        }
        .leftTitle {
          width: 95%;
        }
      }

      .content_hide {
        margin: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .rightcontent {
          margin-left: 20px;
        }
        .content_all {
          width: 250px;

          .head_content_all {
            display: flex;
            flex-direction: row;
            line-height: 35px;
            text-indent: 15px;
            background: #ddd;
            border-radius: 3px 3px 0 0;
            div:nth-of-type(1) {
              width: 80%;
            }
            .sizefont {
              font-size: 10px;
            }
          }

          .content_list {
            // height: 300px;
            // overflow-y: auto;
            border: 1px solid #ddd;
            position: relative;
            .content_list_auto {
              height: 274px;
              overflow-y: auto;
            }

            .charkones {
              display: block;
              margin-left: 25px;
              line-height: 30px;
            }
            .paixulist {
              padding: 15px;
              height: 330px;
              overflow-y: auto;
              .listpaixu {
                line-height: 30px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                .leftspnblock {
                  width: 70%;
                }
                .listnamespan {
                  margin-left: 10px;
                }
                .bleckcolor {
                  color: #f56c6c;
                }
                .rightspan {
                  display: inline-block;
                  text-align: right;
                  display: flex;
                  flex-direction: row;
                  .icon_but {
                    padding: 0 5px;
                  }
                  .icon_but:hover {
                    .anticon {
                      color: a(24 144 255, 1);
                    }
                    //
                  }
                }
              }
            }
          }
          .firstcontent_list {
            text-align: center;
            // height:260px;
            .content_list_auto {
              text-align: left;
            }
            .firstcontent_list {
              height: 326px;
            }
          }
        }
      }
    }
  }
  .multiplechoice {
    text-align: right;
    cursor: pointer;
    color: #409eff;
    padding: 0 15px;
    display: flex;
    margin-left: 16px;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    line-height: 38px;
  }
  .but_que_cancel { 
    margin: 25px;
    margin-right: 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
  /deep/.ant-input-affix-wrapper .ant-input:not(:last-child) {
    border-radius: 50px;
  }
</style>
